import { makeStyles } from '@mui/styles';
import { useEffect } from 'react';
import "./main.scss";
import { useNavigate } from 'react-router-dom';
import EventDetails from './EventDetails.js';
import Hero from "./Hero.js";
import Slogan from "./Slogan.js";
import { Box } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import ReactGA from "react-ga4";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	paper: {
		padding: theme.spacing(2),
		textAlign: 'center',
		color: theme.palette.text.secondary,
	},
}));

const Home = () => {
	const navigate = useNavigate();
	const handleButtonClick = () => {
		navigate('/FashionBazaar');
		ReactGA.event({
			category: "User Interaction",
			action: "Clicked Browse Vendors Button",
			label: "FashionBazaar",
		});
	};

	useEffect(() => {
		// update title and meta tags for this page
		document.title = 'Hand Me Style';

		const setMeta = (name, content) => {
			let el = document.querySelector(`meta[name="${name}"]`);
			if (!el) {
				el = document.createElement('meta');
				el.setAttribute('name', name);
				document.head.appendChild(el);
			}
			el.setAttribute('content', content);
		};

		setMeta('description', 'Discover unique fashion finds at the Fashion Bazaar hosted by Hand Me Style. Explore a curated selection of vendors offering stylish apparel, accessories, and more. Join us for a day of shopping, fun, and fashion!');
		setMeta('keywords', 'Fashion Bazaar, Hand Me Style, fashion event, shopping event, clothing vendors, accessories, style, apparel, henna, henna design, jewelry, bags, shoes, fashion event Texas, fashion pop-up, marketplace, fashion bazaar Fort Worth, fashion bazaar DFW, fashion bazaar vendors, fashion bazaar near me');
		setMeta('viewport', 'width=device-width, initial-scale=1');



		// ensure favicon exists in head
		let icon = document.querySelector("link[rel~='icon']");
		if (!icon) {
			icon = document.createElement('link');
			icon.rel = 'icon';
			document.head.appendChild(icon);
		}
		icon.href = '/favicon.ico';
	}, []);
	return (
		<>
			<Hero />
			<Slogan text="Shop, explore, eat and enjoy—your perfect day out at the Fashion Bazaar awaits." />
			<Box sx={{ textAlign: "center" }}>
				<button className="btn-store" onClick={handleButtonClick}>Browse Vendors</button>
			</Box>
			<Box sx={{ textAlign: "center" }}>
				<Box sx={{ mt: 3, color: "#454141" }}><h2>Follow for more updates:</h2></Box>
				<Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 2 }}>
					<a href="https://www.instagram.com/shazia.a.zaman?igsh=OG41Z29hbGFybmd0" target="_blank" rel="noopener noreferrer">
						<InstagramIcon sx={{ fontSize: 33, color: '#E1306C', cursor: "pointer" }} />
					</a>
					<a href="https://facebook.com/events/s/fashion-bazaar/1172019887641565/" target="_blank" rel="noopener noreferrer">
						<FacebookIcon sx={{ fontSize: 33, color: '#1877F2', cursor: "pointer" }} />
					</a>
					<a href="https://www.youtube.com/watch?v=84aX-ExCPws" target="_blank" rel="noopener noreferrer">
						<YouTubeIcon sx={{ fontSize: 33, color: '#FF0000', cursor: "pointer" }} />
					</a>
				</Box>
			</Box>
			<EventDetails />

		</>
	);
};

export default Home;